function validateEmail(email) {
	const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

	return pattern.test(String(email).toLowerCase());
}

function getFormValues($form) {
	const values = $form.serialize();

	return values;
}

function getFormData($form) {
	return new FormData($form.get(0));
}

function init() {
	$('.map-info__input').on('input.map', (e) => {
		const $input = $(e.currentTarget);
		const $form = $input.closest('form');

		$form.removeClass('is-error');
		$form.find('button').removeAttr('disabled');

		if (!validateEmail($input.val())) {
			$form.addClass('is-error');
			$form.find('button').attr('disabled', true);
		}
	});

	$('.map-info__form').on('submit.map', (e) => {
		e.preventDefault();
		e.stopPropagation();

		const $form = $(e.currentTarget);
		const $formContent = $(e.currentTarget).find('.js-form-content');
		const $formError = $(e.currentTarget).find('.js-form-error');
		const $formSuccess = $(e.currentTarget).find('.js-form-success');

		const values = getFormValues($form);
		const url = $form.attr('action');
		const method = $form.attr('method');
		const isGET = method.toLowerCase() !== 'post' && method.toLowerCase() !== 'put';

		$.ajax({
			url: 'https://h.albato.ru/wh/38/1lfpful/ik7GgfBxOUvqI814IfX4oLKyF%252BZM4IlzHj2Or0frxR4%253D/',
			type: 'GET',
			data: {'email': $form.find('#email').val()},
		})
			.done(() => {
				$formContent.add('.map-info__text').addClass('is-hidden');
				$formSuccess.removeClass('is-hidden');
			})
			.fail(() => {
				$formContent.addClass('is-hidden');
				$formError.removeClass('is-hidden');
			});

		return true;
	});
}

export default {
	init,
};
